import styled, { css, keyframes } from 'styled-components';

// Relements
import Box from 'relements/build/esm/ui/box';

const inProgressStyles = (props) => {
  return {
    margin: '0 1.5px',
    width: 4,
    height: 4,
    background:
      props.variant === 'disable'
        ? props.theme.colors.grey.dark
        : props.theme.colors.blue.haptik,
    borderRadius: '50%',
    '&:first-child': {
      marginLeft: 0,
    },
  };
};

const animate = keyframes`0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }`;

const animation = (props) => {
  return css`
    animation: ${animate} 2s ease-out infinite;
    animation-delay: 0 ${props.delay}s;
  `;
};

const InProgressEllipse = styled('span')(inProgressStyles, animation);

const Wrapper = styled(Box)({
  transform: 'translate(-2px, 3px)',
  marginLeft: '5px',
  padding: 0,
});

export { InProgressEllipse, Wrapper };
